export { default } from './bank-waiting-item';
